import { Checkbox, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Button, TextField, CircularProgress} from "@mui/material";
import InputIcon from "@mui/icons-material/Input";
import OutputIcon from "@mui/icons-material/Output";
import CategoryIcon from "@mui/icons-material/Category";
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useTranslation } from "react-i18next";

const fakeData = [
  {
    account: "fake_account1",
    template: "name",
    workflow_group: "fake_wfg_name",
    warnings: 4,
    type: 'inbound',
  },
  {
    account: "fakeacc",
    template: "fake_template_name",
    workflow_group: "fake_wfg",
    warnings: 0,
    type: 'outbound',
  },
  {
    account: "account",
    template: "template",
    workflow_group: "fake_wfg_name_long",
    warnings: 7,
    type: 'outbound',
  },
  {
    account: "fake_account",
    template: "fake_wf",
    workflow_group: "fake_wfg_name",
    warnings: 1,
    type: 'workflow',
  },
  {
    account: "acc",
    template: "fake_wf",
    workflow_group: "fake_wfg",
    warnings: 2,
    type: 'workflow',
  },
];
const styles = {
  main: {userSelect: 'none', WebkitUserSelect: 'none'},
  td: {padding: '0px 12px', height: "14px"},
  warningIcon: {
    fontSize: "18px", 
    margin: "0 2px 4px 0",
    // color: "#666666",
    //color: yellow[700],
  },
  headerCheckbox: {padding: '0px 8px', height: "14px"},
  checkbox: {padding: "6px !important", height: "26px !important"},
  status: {color: '#666666'},
  icon: {fill: '#666666', marginRight: '4px', fontSize: "19px"},
  loadingCircle: {height: '60px !important', width: '60px !important'},
  loadingText: {fontSize: '16px', fontWeight: '500', marginBottom: '8px'},
  loading: {
    position: 'absolute', 
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center',
    width: '100px',
  },
}

const typeIcons = {
  inbound: <InputIcon sx={styles.icon}/>,
  outbound: <OutputIcon sx={styles.icon}/>,
  workflow: <CategoryIcon sx={styles.icon}/>,
}

//This component is used as a 'Loading' placeholder in the save dialog. 
export default function TableLoading () {
  const { t } = useTranslation();

  const Trows = () => {
    return fakeData.map((o, i) => <TableRow
      key={`tableloading-${i}`}
      sx={{'&:last-child td, &:last-child th': { border: 0 } }}
    >
      <TableCell sx={styles.td}>
        <Checkbox 
          size='small'
          sx={styles.checkbox}
          checked={i%2 === 0}
          disabled={true}
        />
      </TableCell>
      <TableCell sx={styles.td}>
        <div className="flex align-center">
          {typeIcons[o.type]}
          <span className="button-centered-text">{t(o.type.toUpperCase())}</span>
        </div>
      </TableCell>
      <TableCell align="left" sx={styles.td}>
        {o.account}
      </TableCell>
      <TableCell align="left" sx={styles.td}>
        {o.workflow_group}
      </TableCell>
      <TableCell align="left" sx={styles.td}>
        {o.template}
      </TableCell>
      <TableCell align="left" sx={styles.td}>
        <div className="flex align-center" style={styles.status}>
          {o.warnings ? <WarningRoundedIcon sx={styles.warningIcon}/> : <CheckCircleIcon sx={styles.warningIcon}/>}
          {o.warnings ? `${o.warnings} ${t('_FRG_WARNINGS_FOUND')}` : t('LBL_VERIFIED')}
        </div>
      </TableCell>
    </TableRow>);
  }

  return (
    <div className="padding-12 flex align-center justify-center overflow-hidden" style={styles.main}>
      <div style={styles.loading} >
        <div style={styles.loadingText}>{t('LOADING_IND')}</div>
        <CircularProgress sx={styles.loadingCircle} color="primary"/>
      </div>
      <div style={{filter: 'blur(3px)', opacity: '0.75'}}>
        <TableContainer sx={{ boxShadow: 0, overflow: 'none' }} >
          <Table size="small" sx={{ minWidth: 550 }}>
            <TableHead>
              <TableRow>
                <TableCell className="test" sx={styles.headerCheckbox} align="left">
                  <Checkbox size={'small'} checked={false} disabled={true}/>
                </TableCell>
                <TableCell sx={styles.td} align="left">{t('COL_TYPE')}</TableCell>
                <TableCell sx={styles.td} align="left">{t('COL_ACC')}</TableCell>
                <TableCell sx={styles.td} align="left">{t('COL_GROUP')}</TableCell>
                <TableCell sx={styles.td} align="left">{t('COL_NAME')}</TableCell>
                <TableCell sx={styles.td} align="left">{t('COL_STATUS')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <Trows />
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  )
}